import { Box, IconButton, Modal } from '@mui/material';
import { X } from '@phosphor-icons/react';
import NewPublishedForm from '../../../NewPublishedForm/PublishedForm';

export function PreviewModal({
  show,
  onHide,
}: {
  show: boolean;
  onHide: () => void;
}) {
  return (
    <Modal
      open={show}
      onClose={onHide}
      sx={{
        '& .MuiPaper-root': {
          maxWidth: '1190px',
          maxHeight: '100%',
          overflow: 'hidden',
          position: 'relative',
        },
      }}
    >
      <Box sx={{ position: 'relative' }}>
        <IconButton
          onClick={onHide}
          sx={{
            position: 'absolute',
            top: 16,
            right: 16,
            zIndex: 1000,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            color: 'white',
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.7)',
            },
          }}
          aria-label="Fechar modal"
        >
          <X size={24} />
        </IconButton>
        <NewPublishedForm isPreview={true} />
      </Box>
    </Modal>
  );
}
